"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "melito-di-porto-salvo": {
    "16a4505f": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "anna": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "melito-di-porto-salvo"
    }],
    "6b1bb0e6": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "skipSearch": false
    }],
    "arma": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26ac1f88": [{
      "hkey": "e99deeb2",
      "slug": "caredia-lacco",
      "name": "Caredia-Lacco",
      "primary": true,
      "skipSearch": false
    }],
    "caredia": [{
      "hkey": "e99deeb2",
      "slug": "caredia-lacco",
      "name": "Caredia-Lacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a33e1ef": [{
      "hkey": "e99deeb2",
      "slug": "caredia-lacco",
      "name": "Caredia-Lacco",
      "primary": true,
      "skipSearch": false
    }],
    "lacco": [{
      "hkey": "e99deeb2",
      "slug": "caredia-lacco",
      "name": "Caredia-Lacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "melito-di-porto-salvo"
    }],
    "28f13022": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "skipSearch": false
    }],
    "musa": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1da612f": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "skipSearch": false
    }],
    "pallica": [{
      "hkey": "37f360ed",
      "slug": "melito-di-porto-salvo",
      "name": "Melito di Porto Salvo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "033da836": [{
      "hkey": "6e340c14",
      "slug": "pentidattilo",
      "name": "Pentidattilo",
      "primary": true,
      "skipSearch": false
    }],
    "pentedattilo": [{
      "hkey": "6e340c14",
      "slug": "pentidattilo",
      "name": "Pentidattilo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "de1630a4": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "melito-di-porto-salvo"
    }],
    "c31b4aed": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pilati": [{
      "hkey": "47701d61",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "melito-di-porto-salvo"
    }]
  }
};
exports["default"] = _default;